import request from "@/utils/request";
export const getStudentInstances = (params) => request({
    url: "/student-instances",
    method: "get",
    params
});
export const createStudentInstances = (data) => request({
    url: "/student-instances/create",
    method: "post",
    data
});
export const startStudentInstances = (data) => request({
    url: "/student-instances/start",
    method: "post",
    data
});
export const stopStudentInstances = (data) => request({
    url: "/student-instances/stop",
    method: "post",
    data
});
export const resetStudentInstances = (data) => request({
    url: "/student-instances/reset",
    method: "post",
    data
});
export const terminateStudentInstances = (data) => request({
    url: "/student-instances/terminate",
    method: "post",
    data
});
export const addTimeForStudentInstances = (data) => request({
    url: "/student-instances/add-time",
    method: "post",
    data
});
//# sourceMappingURL=studentInstances.js.map